  export const DEFAULT_TOKEN_FONT_FAMILY = 'AG Book Rounded BQ';
  export const DEFAULT_COUNTER_FONT_FAMILY = 'Open Sans';
  export const DEFAULT_FONT_COLOR = '#fff';
  export const DEFAULT_BACKGROUND_COLOR = '#004795';
  export const DEFAULT_TOKEN_FONT_SIZE = 240;
  export const DEFAULT_COUNTER_FONT_SIZE = 110;
